export const isEmptyHtml = (html: string | undefined): boolean =>
  !html ||
  html
    .replace(/<[^>]*>/g, "")
    .replace(/&nbsp;/g, " ")
    .trim() === "";
